import { useEffect } from 'react';
import useScript     from '../google/use_script';

const scriptUrl       = 'https://connect.facebook.net/en_US/sdk.js';
const apiVersion      = 'v3.3';
const productionAppID = '978614082257039';
// const developmentAppID = '1240869489362211';


export default function FacebookAuthWeb({ state, updateState }) {
  const [ scriptLoaded, scriptError ] = useScript(scriptUrl);

  // once the script is loaded, initialize the client. if the script fails, set
  // error state
  useEffect(() => {
    function updateLoginStatus(response) {
      const { status }       = response;
      const isSignedIn       = status === 'connected';
      const { authResponse } = response;
      const accessToken      = authResponse?.accessToken;
      updateState({ isSignedIn, accessToken });
    }

    if (!state.initialized || !state.error) {

      if (scriptError) {
        updateState({ error: true });
        return () => {};
      } else if (scriptLoaded) {
        initializeFacebookApi();

        // once the client is initialized, check login status and add event subscriptions
        window.FB.getLoginStatus(updateLoginStatus);
        window.FB.Event.subscribe('auth.statusChange', updateLoginStatus);

        updateState({ initialized: true });

        return () => {
          window.FB.Event.unsubscribe('auth.statusChange', updateLoginStatus);
        };
      }

    }
    return () => {};
  }, [ scriptError, scriptLoaded, state.error, state.initialized, updateState ]);

  return null;
}

// Facebook API initializer
function initializeFacebookApi() {
  window.FB.init({
    appId:   productionAppID,
    cookie:  true,
    xfbml:   true,
    version: apiVersion
  });
}
